import { Datagrid, DateField, List, NumberField, ReferenceField, TextField } from 'react-admin';

export const Survey_onlineList = () => (
    <List sort={{ field: 'date_created', order: 'DESC' }}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="niplama_petugas" />
            <ReferenceField label="Nama Petugas PST" source="niplama_petugas" reference="petugas_pst" link={false} >
                <TextField source="nama" />
            </ReferenceField>
            <NumberField source="p1" />
            <DateField source="date_created" />
        </Datagrid>
    </List>
);